export type GuiaTarifaStatus = 'idle' | 'loading' | 'ok' | 'error';

export interface IGuiaTarifaTotales {
    importe: number;
    subtotal: number;
    iva: number;
    retencion: number;
    total: number;
    cantidadTotal: number;
    ivaSinAcc: number;
    pesoFacturado: number;
    peso: number;
    volumen: number;
    descuento: number | null;
    descuentoMsj?: string | null;
    cobroEnDestino?: number | null;
    paridad?: number | null;
}

export interface IGuiaTarifaMercancia {
    cantidad: number;
    embalajeId: number;
    alto?: number | null;
    ancho?: number | null;
    largo?: number | null;
    volumen?: number | null;
    peso?: number | null;
    pesoFacturado?: number | null;
    esNoEstibable: number;
    convenioId?: number | null;
    servicioId: number;
    densidad: number;
    altoReal?: number | null;
}

export interface IGuiaTarifaDesgloseFlete {
    servicioId: number;
    convenioId: number;
    promocionId: number;
    tarifaBase: number;
    pesoFacturado: number;
    valor: number;
}

export interface IGuiaTarifaDesgloseAjuste {
    convenioId: number;
    promocionId: number;
    tarifaBase: number;
    pesoFacturado: number;
    valor: number;
}

export interface IGuiaTarifaDesgloseSeguro {
    convenioId: number;
    tarifaBase: number;
    tipoSeguroId: number;
    valor: number;
}

export interface IGuiaTarifaConcepto {
    conceptoId: number;
    costo: number;
    cantidad: number;
    convenioId: number;
    esOrigen: number;
    esDestino: number;
    cantidadOrigen: number;
    cantidadDestino: number;
}

export interface IGuiaTarifaCombustible {
    valor: number;
    costoCombustible: number;
}

export interface IGuiaTarifaCruce {
    concepto?: string;
    convenioId: number;
    pesoFacturado: number;
    tarifaBase: number;
    valor: number;
    cruce?: string;
}

export interface IGuiaTarifa {
    status: GuiaTarifaStatus;
    errorMessage: string;
    dirty: boolean;
    mercancias: IGuiaTarifaMercancia[];
    desgloseFlete: IGuiaTarifaDesgloseFlete[];
    desgloseSeguro: IGuiaTarifaDesgloseSeguro[];
    desgloseRad: IGuiaTarifaDesgloseFlete[];
    desgloseEad: IGuiaTarifaDesgloseFlete[];
    desgloseAjuste: IGuiaTarifaDesgloseAjuste[];
    desgloseCruce: IGuiaTarifaCruce[];
    conceptos: IGuiaTarifaConcepto[];
    combustible: IGuiaTarifaCombustible[];
    totales: IGuiaTarifaTotales | null;
}

export const initialGuiaTarifa: IGuiaTarifa = {
    status: 'idle',
    errorMessage: '',
    dirty: true,
    mercancias: [],
    desgloseFlete: [],
    desgloseSeguro: [],
    desgloseRad: [],
    desgloseEad: [],
    desgloseAjuste: [],
    desgloseCruce: [],
    conceptos: [],
    combustible: [],
    totales: null
};
